import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
export const MARKET_DATA_CORRECT = 'market.data.correct';
export const MARKET_DATA_HISTORY = 'market.data.history';
function descriptor(id, name, permission, readOnly) {
    return {
        id,
        name,
        implementationStatus: 'AVAILABLE',
        labelKey: readOnly ? 'operations.marketData.history.label' : 'operations.marketData.correct.label',
        descriptionKey: readOnly
            ? 'operations.marketData.history.description'
            : 'operations.marketData.correct.description',
        permission,
        permissionId: permission,
        module: 'MARKET_DATA',
        requiredModules: ['MARKET_DATA'],
        requiresEntitledModule: true,
        requiredAal: readOnly ? AuthenticationAssuranceLevel.AAL1 : AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
        allowedPersonas: ['ORG_ADMIN'],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        requestedScope: { branchId: [{ source: 'query', field: 'branchId' }] },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: readOnly ? IdempotencyPolicy.NOT_APPLICABLE : IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: readOnly ? ConcurrencyPolicy.NONE : ConcurrencyPolicy.OPTIMISTIC,
        auditPolicy: readOnly ? AuditPolicy.READ : AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: id,
        allowedActorTypes: [ActorType.USER],
        httpMethods: readOnly ? ['GET'] : ['POST'],
        isReadOnly: readOnly,
        isFinancial: true,
        supportDelegationEligible: readOnly,
        delegationPolicy: readOnly ? 'READ_ONLY' : 'NOT_ALLOWED',
        accessType: readOnly ? 'READ' : 'ADMIN',
    };
}
export const MARKET_DATA_CORRECTION_OPERATIONS = {
    [MARKET_DATA_CORRECT]: descriptor(MARKET_DATA_CORRECT, 'Correct Market Data Observation', 'organization:market-data:manage', false),
    [MARKET_DATA_HISTORY]: descriptor(MARKET_DATA_HISTORY, 'Read Market Data Correction History', 'organization:market-data:read', true),
};
